import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PlansService {

  constructor(private _apiService: ApiService) { }

  getPlans() {
    return this._apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.PLAN);
  }

  getActivePlan() {
    return this._apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUBSCRIPTIONS + API_ENDPOINTS.API.ACTIVE_SUBSCRIPTION)
  }

  cancelSubscription(activePlanId) {
    return this._apiService.put(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUBSCRIPTIONS + API_ENDPOINTS.API.CANCEL_SUBSCRIPTION)
  }

  autoRenewSubscription(params) {
    return this._apiService.put(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.AUTO_RENEW_SUBSCRIPTION,params)
  }

  buySubscription(params) {
    return this._apiService.post(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUBSCRIPTIONS, params);
  }

  checkBBBPlan(params) {
    return this._apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CHECK_BBB_PLAN, params);
  }

  bbbPlanConfirm(params) {
    return this._apiService.put(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.BBB_PLAN_CONFIRMATION, params);
  }

  updatePlanCardFlag(params){
    return this._apiService.put(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.UPDATE_PLAN_CARD_FLAG, params);
  }

  upgradePlan(params) {
    return this._apiService.put(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUBSCRIPTIONS + API_ENDPOINTS.API.UPGRADE_SUBSCRIPTION, params);
  }

  getAddOns(planID?) {
    return this._apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUBSCRIPTIONS + API_ENDPOINTS.API.LIST_ADD_ONS + (planID ? ('?plan_id=' + planID) : ''));
  }

  buyAddons(params) {
    return this._apiService.post(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUBSCRIPTIONS + API_ENDPOINTS.API.PURCHASE_ADD_ONS, params);
  }

  getCurrentAddOns(params) {
    return this._apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.PURCHASED_ADD_ONS + '?category=' + params);
  }

  getCards() {
    return this._apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CREDIT_CARDS);
  }

  removeCard(cardId) {
    return this._apiService.delete(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CREDIT_CARDS + '/' + cardId);
  }

  autoRenewAddonToggle(purchsed_addon_id, params) {
    return this._apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.PURCHASED_ADD_ONS + '/' + purchsed_addon_id + API_ENDPOINTS.API.AUTO_RENEW_ADD + '?' + params);
  }

  setCardDefault(cardId) {
    return this._apiService.put(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CREDIT_CARDS + '/' + cardId);
  }
  GetContentIdRespone(cardId) {
    return this._apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONTENTS + '/' + cardId);
    
  }

  ContentIdArray=[]
  ContentIdArraynumer:any
}